import React, { CSSProperties } from 'react';
import { Marker } from './HBMarker.styles';

export interface HBMarkerProps {
    /** CSS color value for the triangle marker. Accepts any valid CSS color string. */
    color: string;
    /** CSS `top` offset for the absolutely-positioned arrow marker. */
    positionTop?: CSSProperties['top'];
}

const HBMarker = ({ color, positionTop }: HBMarkerProps) => {
    return (
        <Marker className="marker" color={color} positionTop={positionTop} />
    );
};

export default HBMarker;
